<template>
  <div class="ap">
    <div v-if="loading" class="ap-note">Loading…</div>
    <div v-else-if="error" class="ap-note ap-error">{{ error }}</div>
    <PageCanvas v-else-if="isSpec" :page-id="id" :spec="page.spec" :widgets="page.widgets || {}" />
    <AgentHtmlCard
      v-else
      :html="page.html"
      :sources="page.sources || []"
      :page-id="id"
      class="sensitive"
      data-demo-blur
    />
  </div>
</template>

<script>
import axios from 'axios';
import AgentHtmlCard from './AgentHtmlCard.vue';
import PageCanvas from './widgets/PageCanvas.vue';

export default {
  name: 'AgentPageView',
  components: { AgentHtmlCard, PageCanvas },
  props: { id: { type: Number, required: true } },
  data() {
    return { page: null, loading: true, error: '' };
  },
  computed: {
    isSpec() {
      return !!(this.page && this.page.spec && (this.page.spec.placements || []).length);
    },
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      try {
        const { data } = await axios.get(`/api/impact_analytics/agent-pages/${this.id}/`);
        this.page = data;
        document.title = `${data.title} | Kairon Health`;
      } catch (error) {
        this.error = error?.response?.status === 404
          ? 'No page with that name.'
          : 'That page could not be loaded.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.ap { width: 100%; }
.ap-note { padding: 32px; font-size: 13px; color: #56534d; }
.ap-error { color: #c23a28; }
</style>
